export default "__VITE_ASSET__BLWoZIC5__";